<script setup>
import { useRouter, useRoute } from 'vue-router'

const props = defineProps({
  variant: { type: String, default: 'default' },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  type: { type: String, default: 'button' },
  to: { type: [String, Object], default: null },
  full: { type: Boolean, default: false },
  ghost: { type: Boolean, default: false } 
})

const emit = defineEmits(['click'])
const router = useRouter()
const route = useRoute()

function handleClick(e) {
  if (props.to) {
    router.push(props.to)
  } else {
    emit('click', e)
  }
}

function isActive() {
  if (!props.to) return false
  const path = typeof props.to === 'string' ? props.to : props.to.path
  return route.path.startsWith(path)
}

const variantClasses = {
  default: 'bg-[var(--button-background)] text-[var(--button-text)]',
  success: 'bg-[var(--success-bg)] text-[var(--success-text)]',
  danger: 'bg-[var(--danger-bg)] text-[var(--danger-text)]',
  warning: 'bg-[var(--warning-bg)] text-[var(--warning-text)]',
  info: 'bg-[var(--info-bg)] text-[var(--info-text)]',
}
</script>

<template>
  <div>
    <button
      :type="type"
      :disabled="disabled || loading"
      @click="handleClick"
      class="relative rounded-3xl px-6 py-2 rounded !text-white font-medium flex items-center justify-center gap-2 transition-all
             disabled:opacity-50 disabled:!cursor-not-allowed
             hover:brightness-105 active:brightness-95
             cursor-pointer"
      :class="[
        ghost 
          ? 'bg-transparent text-[var(--button-text)] hover:bg-[var(--button-hover)] border border-solid border-[var(--button-border)]' 
          : variantClasses[variant],
        isActive() && 'ring-2 ring-[var(--button-hover)]',
        full && 'w-full'
      ]"
    >
      <span :class="{ 'invisible': loading }">
        <slot />
      </span>
      <div v-if="loading">...</div>
    </button>
  </div>
</template>
